var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivestep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.418 17H8.896v-.91l3.446-3.827c.51-.58.861-1.049 1.053-1.409.196-.364.293-.74.293-1.127 0-.52-.157-.946-.471-1.279-.315-.332-.734-.499-1.258-.499-.629 0-1.119.18-1.47.54-.346.356-.52.852-.52 1.49H8.706c0-.916.294-1.656.882-2.221.592-.565 1.383-.848 2.372-.848.925 0 1.657.244 2.194.732.538.483.807 1.128.807 1.934 0 .98-.624 2.147-1.873 3.5l-2.666 2.892h4.997V17z",
    fill: "#fff"
  })));
}
SvgActivestep2.displayName = 'Activestep2';
export default SvgActivestep2;